import { render, staticRenderFns } from "./zametka.vue?vue&type=template&id=73a9056e&scoped=true&"
import script from "./zametka.vue?vue&type=script&lang=js&"
export * from "./zametka.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73a9056e",
  null
  
)

export default component.exports